var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-no-message-box"},[_c('div',{staticClass:"tc-100"}),_vm._m(0),_c('div',{staticClass:"my-no-message-inner-font"},[_vm._v(_vm._s(_vm.msg))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-no-message-inner-img-box"},[_c('img',{attrs:{"src":require("../../../assets/img/noMessage/no-message1.png"),"alt":""}})])
}]

export { render, staticRenderFns }